/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Sethuram Gautham's Portfolio",
  description:
    "A dedicated data engineer passionate about building scalable and efficient systems. Experienced in working with large language models (LLMs), LangChain, Retrieval-Augmented Generation (RAG), and data pipelines to create impactful and innovative solutions.",
  og: {
    title: "Sethuram Gautham Portfolio",
    type: "website",
    url: "http://sethuramgautham.com/",
  },
};

//Home Page
const greeting = {
  title: "Sethuram Gautham",
  logo_name: "SethuramGautham",
  nickname: "Data_LLM_enthusiast", // or "data_pipeline_architect", "llm_data_engineer", "data_llm_explorer"
  subTitle:
    "Data is a precious thing and will last longer than the systems themselves. Passionate about building robust Data Lakes and scalable Data pipelines, while also exploring the transformative potential of Large Language Models (LLMs) in unlocking insights from complex datasets.",
  resumeLink:
    "https://drive.google.com/file/d/1ExnLbRrEl9SNhejSDwGApMTnhKWeGBDS/view?usp=drive_link",
  portfolio_repository: "",
  githubProfile: "https://github.com/Sethuram2003",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/Sethuram2003",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/sethuram-gautham-r-851733205/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:sethuramgautha.rajakumar@stonybrook.edu",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  // {
  //   name: "X-Twitter",
  //   link: "https://twitter.com/ashutosh_1919",
  //   fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
  //   backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  // },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com/laymanbrother.19/",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  // {
  //   name: "Instagram",
  //   link: "https://www.instagram.com/layman_brother/",
  //   fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //   backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  // },
];

const skills = {
  data: [
    {
      title: "Data Engineering",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Proficient in building and managing data pipelines using tools like Apache Kafka, Apache NiFi, and Apache Airflow. Skilled in real-time data ingestion, stream processing, and workflow orchestration for scalable data solutions.",
        "⚡ Experienced in large-scale data processing with Apache Hadoop, Apache Spark, and Apache Hive. Skilled in ETL operations, data lake management, and distributed computing for efficient data storage and analytics.",
        "⚡ Skilled in cloud-based big data tools like AWS Glue, Google BigQuery, and Snowflake. Proficient in data warehousing, serverless ETL, and optimizing data workflows for performance and cost-efficiency.",
      ],
      softwareSkills: [
        {
          skillName: "Apache Kafka",
          fontAwesomeClassname: "simple-icons:apachekafka",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Apache Hadoop",
          fontAwesomeClassname: "simple-icons:apachehadoop",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Apache Spark",
          fontAwesomeClassname: "logos-apache-spark",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Apache Hive",
          fontAwesomeClassname: "simple-icons:apachehive",
          style: {
            backgroundColor: "transparent",
            // color: "#FDEE21",
          },
        },
        {
          skillName: "AWS Glue",
          fontAwesomeClassname: "logos-aws-glue",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Google BigQuery",
          fontAwesomeClassname: "simple-icons:googlebigquery",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Snowflake",
          fontAwesomeClassname: "simple-icons:snowflake",
          style: {
            backgroundColor: "transparent",
            color: "#29B5E8",
          },
        },
      ],
    },
    {
      title: "LLM-Driven Solutions",
      fileName: "FullStackImg",
      skills: [
        "⚡ Proficient in leveraging Hugging Face and Sentence Transformers for fine-tuning and deploying language models, enabling NLP tasks like text classification and semantic search. Skilled in fine-tuning LLMs using LoRA and Unsloth techniques for efficient model adaptation.",
        "⚡ Experienced in developing AI agents using frameworks like LangChain and Letta, enabling conversational agents and context-aware automation pipelines. Capable of integrating fine-tuned LLMs and multimodal models like LLaVA and DeepSeek for enhanced functionality.",
        "⚡ Skilled in developing and fine-tuning multimodal models like Llama3.1, DeepSeek-r1, LLaVA, and Janus-Pro for tasks involving text, image, and other data modalities. Proficient in using Ollama to manage and run these models locally, and applying LoRA and Unsloth techniques for real-world use cases.",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Hugging Face",
          fontAwesomeClassname: "simple-icons:huggingface",
          style: {
            color: "#FFFF01", // Yellow color
          },
        },
        {
          skillName: "OpenAI",
          fontAwesomeClassname: "simple-icons:openai",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#003366", // Medium dark blue color
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Ollama",
          fontAwesomeClassname: "simple-icons:ollama",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain", // LangChain icon
          style: {
            color: "#6C63FF", // A color for LangChain (purple as an example)
          },
        },
      ],
    },
    {
      title: "Cloud Computing Expertise",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Hands-on experience with multiple cloud platforms, including AWS, GCP, and Azure, focusing on infrastructure setup and optimization",
        "⚡ Proficient in hosting and maintaining dynamic websites on virtual machine instances with secure database integration using MySQL, PostgreSQL, and MongoDB",
        "⚡ Skilled in deploying deep learning models on cloud services (e.g., AWS SageMaker, GCP AI Platform) for real-time inference on mobile and edge devices",
        "⚡ Expertise in configuring and managing data streaming pipelines using Apache Kafka, AWS Kinesis, and Google Pub/Sub for seamless data flow between databases and servers",
      ],

      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
    // {
    //   title: "UI/UX Design",
    //   fileName: "DesignImg",
    //   skills: [
    //     "⚡ Designing highly attractive user interface for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Adobe XD",
    //       fontAwesomeClassname: "simple-icons:adobexd",
    //       style: {
    //         color: "#FF2BC2",
    //       },
    //     },
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E",
    //       },
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00",
    //       },
    //     },
    //     {
    //       skillName: "Inkscape",
    //       fontAwesomeClassname: "simple-icons:inkscape",
    //       style: {
    //         color: "#000000",
    //       },
    //     },
    //   ],
    // },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/u/Sethur2003/",
    },
    // {
    //   siteName: "HackerRank",
    //   iconifyClassname: "simple-icons:hackerrank",
    //   style: {
    //     color: "#2EC866",
    //   },
    //   profileLink: "https://www.hackerrank.com/layman_brother",
    // },
    // {
    //   siteName: "Codechef",
    //   iconifyClassname: "simple-icons:codechef",
    //   style: {
    //     color: "#5B4638",
    //   },
    //   profileLink: "https://www.codechef.com/users/ashutosh_1919",
    // },
    // {
    //   siteName: "Codeforces",
    //   iconifyClassname: "simple-icons:codeforces",
    //   style: {
    //     color: "#1F8ACB",
    //   },
    //   profileLink: "http://codeforces.com/profile/layman_brother",
    // },
    {
      siteName: "Credly",
      iconifyClassname: "simple-icons:credly",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.credly.com/users/sethuram-gautham-rajakumar",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/sethuramgautham",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Sri Sivasubramaniya Nadar College of Engineering",
      subtitle: "B.Tech. in Electrical and Electronics Engineering",
      logo_path: "SSN_transparent.png",
      alt_name: "SSN",
      duration: "2020 - 2024",
      descriptions: [
        "⚡ I have completed advanced mathematics courses such as Linear Algebra and Calculus, Complex Functions and Laplace Transforms, Transform Techniques and Partial Differential Equations, and Numerical Analysis and Computational Methods, which have strengthened my problem-solving and analytical skills.",
        "⚡ I gained practical experience through projects involving Raspberry Pi integration, where I applied my knowledge of electronics and data systems, alongside working on machine learning-based predictive maintenance projects to optimize operations and enhance system reliability.",
        "⚡ As a Crowd Committee member, I was responsible for managing and organizing the crowd during major college events. Additionally, I served as an event coordinator and successfully organized tech events like 'Robo Wars' during the college tech fest, showcasing my leadership and event management skills.",
      ],
      website_link: "https://www.ssn.edu.in/",
    },
    {
      title: "Stony Brook University",
      subtitle: "M.S. in Data Science",
      logo_path: "SBU_transparent.png",
      alt_name: "Stony Brook University",
      duration: "2024 - 2026",
      descriptions: [
        "⚡ I have pursued a diverse range of courses in Data Analysis, Probability, Statistical Learning, Statistical Computing, Data Structures and Algorithms, Data Management, Cloud Computing, Big Data Analysis.",
        "⚡ I developed a context-aware AI agent with dynamic memory using LLaMA 3.1 and Letta, enabling real-time, personalized task execution—enhancing user interaction by 90% through adaptive learning and memory updates.",
        "⚡ I am an active member of the AI and Robotics communities at Stony Brook University, collaborating on cutting-edge projects and participating in initiatives to drive technological innovation.",
      ],
      website_link: "https://www.stonybrook.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Artificial Intelligence",
      subtitle: "- David J. Malan",
      logo_path: "harvard_transparent.png",
      certificate_link:
        "https://certificates.cs50.io/a81582bf-5ff8-47a9-b3a1-0b5be24a91a2.pdf?size=letter",
      alt_name: "Harvard University",
      color_code: "#8C151599",
    },
    {
      title: "Arduino Platform and C Programming",
      subtitle: "- Ian Harris",
      logo_path: "UCI.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/PLD9GXN7W3KG",
      alt_name: "Arduino Platform and C Programming",
      color_code: "#FFFFFF",
    },
    {
      title: "Data, Data, Everywhere",
      subtitle: "- Google",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5EGN35V7Z6GL",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Machine Learning on AWS",
      subtitle: "- AWS Trainng",
      logo_path: "aws_transparent.png",
      certificate_link:
        "https://www.credly.com/badges/c3d8e593-cf11-4d21-b550-efe10eb2865e",
      alt_name: "AWS",
      color_code: "#FFFFFF",
    },
    {
      title: "Industry 4.0 And Industrial Iot",
      subtitle: "- Sudip Misra",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1LkPNh2FCqPN6a_XgQ8smJlOskxbTJxh3/view?usp=drive_link",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    // {
    //   title: "Big Data",
    //   subtitle: "- Kim Akers",
    //   logo_path: "microsoft_logo.png",
    //   certificate_link:
    //     "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
    //   alt_name: "Microsoft",
    //   color_code: "#D83B0199",
    // },
    // {
    //   title: "Advanced Data Science",
    //   subtitle: "- Romeo Kienzler",
    //   logo_path: "ibm_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },
    // {
    //   title: "Advanced ML on GCP",
    //   subtitle: "- GCP Training",
    //   logo_path: "google_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
    //   alt_name: "Google",
    //   color_code: "#0C9D5899",
    // },
    {
      title: "LLMs as Operating Systems: Agent Memory",
      subtitle: "- Sarah Wooders",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://learn.deeplearning.ai/accomplishments/c414c634-819f-4670-aae0-21149336990c?usp=sharing",
      alt_name: "deeplearning.ai",
      color_code: "#0F000099",
    },
    // {
    //   title: "Fullstack Development",
    //   subtitle: "- Jogesh Muppala",
    //   logo_path: "coursera_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
    //   alt_name: "Coursera",
    //   color_code: "#2A73CC",
    // },
    // {
    //   title: "Kuberenetes on GCP",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
    {
      title: "Fuzzy Sets, Logic and Systems",
      subtitle: "- Nishchal Kumar Verma",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/15bbsAgQ9NfsburW_CLcgTUijH3-W5SF3/view?usp=drive_link",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Databases on AWS",
      subtitle: "- AWS Trainng",
      logo_path: "aws_transparent.png",
      certificate_link:
        "https://www.credly.com/badges/a8a85ce4-3bde-4618-8fb1-d8797977c700",
      alt_name: "AWS",
      color_code: "#FFFFFF",
    },
    {
      title: "Networking on AWS",
      subtitle: "- AWS Trainng",
      logo_path: "aws_transparent.png",
      certificate_link:
        "https://www.credly.com/badges/82144b11-aec2-4c1d-b89b-a14ba57678c7",
      alt_name: "AWS",
      color_code: "#FFFFFF",
    },
    // {
    //   title: "Cloud Architecture",
    //   subtitle: "- Qwiklabs",
    //   logo_path: "gcp_logo.png",
    //   certificate_link:
    //     "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
    //   alt_name: "GCP",
    //   color_code: "#4285F499",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Internships",
  description:
    "I have worked as an AI Engineer and Full Stack Developer, where I helped design and build innovative AI agents during my internships. I’ve also collaborated with well-established companies as an AI Developer. Beyond my technical roles, I enjoy organizing events and actively contribute to various open-source communities as a representative",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Internships",
      work: true,
      experiences: [
        {
          title: "Associate Electrical Engineer - Intern",
          company: "EQuad Engineering Services Pvt.Ltd",
          company_url: "http://equadservices.in/",
          logo_path: "equad.png",
          duration: "Jan 2023 - Feb 2023",
          location: "Chennai, Tamilnadu, IND",
          description:
            "At EQuad Engineering Services Pvt. Ltd, I worked as a Trainee Engineer developing a system that converted 2D images into precise 3D models using OpenCV and Open3D, which were then integrated with an industrial milling machine for automated carving. By optimizing the image-to-3D workflow, I improved processing speed and manufacturing precision, showcasing my ability to merge software development, image processing, and industrial automation.",
          color: "#000000",
        },
        {
          title: "Associate Software Engineer - Intern",
          company: "HGS Digital, LLC",
          company_url: "https://hgs.cx/",
          logo_path: "hgs_logo.png",
          duration: "May 2025 - Present",
          location: "New York, New York, USA",
          description:
            "I am currently building advanced AI voice agents and full-stack automation systems across domains like healthcare, finance, and customer support. My work focuses on developing scalable, intelligent agents that enhance efficiency and reduce human dependency. I have hands-on experience in fine-tuning models, deploying solutions using Azure Cloud Functions, and integrating complex workflows with MCP servers, LangGraph, n8n, and LangFlow. These AI agents are designed to operate faster, smarter, and more reliably—driving automation and intelligent decision-making across multiple industries.",
          color: "#0879bf",
        },
        // {
        //   title: "Android and ML Developer",
        //   company: "Muffito Incorporation",
        //   company_url: "https://www.linkedin.com/company/muffito-inc/about/",
        //   logo_path: "muffito_logo.png",
        //   duration: "May 2018 - Oct 2018",
        //   location: "Pune, Maharashtra",
        //   description:
        //     "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
        //   color: "#9b1578",
        // },
        // {
        //   title: "Android Developer",
        //   company: "FreeCopy Pvt. Ltd.",
        //   company_url: "https://www.linkedin.com/company/freecopy/about/",
        //   logo_path: "freecopy_logo.png",
        //   duration: "Nov 2017 - Dec 2017",
        //   location: "Ahmedabad, Gujarat",
        //   description:
        //     "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
        //   color: "#fc1f20",
        // },
      ],
    },
    // {
    //   title: "Internships",
    //   experiences: [
    //     {
    //       title: "Machine Learning Intern",
    //       company: "TikTok Inc.",
    //       company_url: "https://www.tiktok.com/en/",
    //       logo_path: "tiktok_logo.png",
    //       duration: "May 2022 - Aug 2022",
    //       location: "San Francisco, USA",
    //       description:
    //         "Building new features on the backend recommendation system, specifically ranking algorithms for Ads that touch hundreds of millions of people around the world. Improving online and offline content ranking algorithms by performing hard sample data replays for training steps.",
    //       color: "#000000",
    //     },
    //     {
    //       title: "Data Science Research Intern",
    //       company: "Delhivery Pvt. Ltd.",
    //       company_url: "https://www.delhivery.com/",
    //       logo_path: "delhivery_logo.png",
    //       duration: "May 2019 - Sept 2019",
    //       location: "Gurgaon, Haryana",
    //       description:
    //         "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
    //       color: "#ee3c26",
    //     },
    //     {
    //       title: "Data Science Intern",
    //       company: "Intel Indexer LLC",
    //       company_url:
    //         "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
    //       logo_path: "intel_logo.jpg",
    //       duration: "Nov 2018 - Dec 2018",
    //       location: "Work From Home",
    //       description:
    //         "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
    //       color: "#0071C5",
    //     },
    //   ],
    // },
    // {
    //   title: "Volunteerships",
    //   experiences: [
    //     {
    //       title: "Google Explore ML Facilitator",
    //       company: "Google",
    //       company_url: "https://about.google/",
    //       logo_path: "google_logo.png",
    //       duration: "June 2019 - April 2020",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
    //       color: "#4285F4",
    //     },
    //     {
    //       title: "Microsoft Student Partner",
    //       company: "Microsoft",
    //       company_url: "https://www.microsoft.com/",
    //       logo_path: "microsoft_logo.png",
    //       duration: "Aug 2019 - May 2020",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
    //       color: "#D83B01",
    //     },
    //     {
    //       title: "Mozilla Campus Captain",
    //       company: "Mozilla",
    //       company_url: "https://www.mozilla.org/",
    //       logo_path: "mozilla_logo.png",
    //       duration: "Oct 2019 - May 2020",
    //       location: "Kurnool, Andhra Pradesh",
    //       description:
    //         "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
    //       color: "#000000",
    //     },
    //     {
    //       title: "Developer Students Club Member",
    //       company: "DSC IIITDM Kurnool",
    //       company_url:
    //         "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
    //       logo_path: "dsc_logo.png",
    //       duration: "Jan 2018 - May 2020",
    //       location: "Kurnool, Andhra Pradesh",
    //       description:
    //         "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
    //       color: "#0C9D58",
    //     },
    //     {
    //       title: "Developer Program Member",
    //       company: "Github",
    //       company_url: "https://github.com/",
    //       logo_path: "github_logo.png",
    //       duration: "July 2019 - PRESENT",
    //       location: "Work From Home",
    //       description:
    //         "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
    //       color: "#181717",
    //     },
    //   ],
    // },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I enjoy working with the latest technologies to create innovative solutions in data science and IoT. From building data pipelines and predictive models to deploying applications on cloud platforms, I focus on delivering impactful and efficient results.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    // {
    //   id: "neuro-symbolic-sudoku-solver",
    //   name: "Neuro-Symbolic Sudoku Solver",
    //   createdAt: "2023-07-02T00:00:00Z",
    //   description: "Paper published in KDD KiML 2023",
    //   url: "https://arxiv.org/abs/2307.00653",
    // },
    // {
    //   id: "mdp-diffusion",
    //   name: "MDP-Diffusion",
    //   createdAt: "2023-09-19T00:00:00Z",
    //   description: "Blog published in Paperspace",
    //   url: "https://blog.paperspace.com/mdp-diffusion/",
    // },
    {
      id:
        "Design and Implementation of Real Time Monitoring System of Diesel Generator using IoT",
      name:
        "Design and Implementation of Real Time Monitoring System of Diesel Generator using IoT",
      createdAt: "2023-4-2T00:00:00Z",
      description: "Research published in IEEE",
      url: "https://ieeexplore.ieee.org/document/10537268",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "my_image_g.png",
    description:
      "Feel free to reach out to me on any social media platform! I typically respond within 24 hours. I'm happy to assist with topics like Machine Learning, Artificial Intelligence, Cloud technologies, and Open Source contributions.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Stony Brook University",
    locality: "Stony Brook",
    country: "USA",
    region: "New York",
    postalCode: "11755",
    streetAddress: "Stony Brook University",
    avatar_image_path: "address_image.svg",
    location_map_link:
      "https://search.brave.com/search?q=stonybrook+university+address&source=desktop&map_src=result&view=full&bbox=-73.261085%2C40.816981999999996%2C-72.971555%2C41.011717999999995&loc_id=KLUv_WB2AMUFAKJKIxhQ9_MG8Fhc742BVIzxNxUlKtn6yMyMCQFctdfG6DCIhImkEvbOf-pXV6M9f6JeSVzVtz1tzr3-XNJVQmVC7MrLhJTO8taEy-sA49vrqn5tPHOTYkonrlEW24wD9AGT7FfYoh1Y3meQ1_3XBOGYUMP-p4qsD9BgZZGB64b0tRKUCRurzgSBL4Gn1fXSIRAAFrO4Da6OAgSeQMQJzFtABkYwRZRW9rr5fuAMaAcyBmw2owQY4JA%3D", // Update this with the correct link to your location.
  },

  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
